import axios from 'axios'
import { camelCaseKeys } from '@/util'
import { setError } from './errorParser'

const _axios = axios.create({
  baseURL: `${process.env.common.niceApi.host}/api`,
})

_axios.interceptors.request.use(
  async (config) => {
    config.headers.Authorization = `Bearer ${process.env.common.niceApi.Authorization}`
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

_axios.interceptors.response.use(
  (resp) => {
    return Promise.resolve(camelCaseKeys(resp))
  },
  async (error) => {
    const { response } = error
    const errorResponse = setError(response)
    return Promise.reject(camelCaseKeys(errorResponse))
  },
)

export default _axios
